import clsx from "clsx";
import { ComponentPropsWithoutRef, ReactElement } from "react";

interface SidebarHeadingProps extends ComponentPropsWithoutRef<"h3"> {
  fullWidth?: boolean;
}

export const SidebarHeading = ({
  className,
  fullWidth,
  ...props
}: SidebarHeadingProps): ReactElement => (
  <h3
    {...props}
    className={clsx(
      className,
      "mb-1 text-xs/6 font-medium text-zinc-500 dark:text-zinc-400",
      { "px-2": !fullWidth },
    )}
  />
);
